import React, { Component } from "react"
import PropTypes from "prop-types"

/**
 * @param {String} 'left'|'right' - Direction of arrow
 * @param {function} onClick - Click event handler
 */

const SvgArrowLeftIcon = () => (
  <svg
    style={styles.arrows}
    viewBox="0 0 50 80">
    <title>Arrow left</title>
    <polyline
      fill="none"
      stroke="#FFF"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="45.63,75.8 0.375,38.087 45.63,0.375 " />
  </svg>
)

const SvgArrowRightIcon = () => (
  <svg
    style={styles.arrows}
    viewBox="0 0 50 80">
    <title>Arrow left</title>
    <polyline
      fill="none"
      stroke="#FFF"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="0.375,0.375 45.63,38.087 0.375,75.8" />
  </svg>
)


const ArrowIcon = ({ direction = "left", onClick }) => (
  <div
    style={styles.arrowWrapper}
    onClick={() => {
      onClick()
    }}>
    {direction === "left" && <SvgArrowLeftIcon />}
    {direction === "right" && <SvgArrowRightIcon />}

  </div>
)

export default ArrowIcon

const styles = {
  arrowWrapper: {
    width: "1.4em",
    height: "1.4em",
    padding: "8px",
    position: "relative",
    cursor: "pointer"
  }
}



// WEBPACK FOOTER //
// ./src/containers/arrow-icon/index.jsx